import { useState } from 'react';
import { useSelector } from 'react-redux';
import '../../assets/styles.css'

export default function Assemblies({ onItemSelect }) {
  const { cacheAssemblies, selectedPart } = useSelector(state => state.rules);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index, item) => {
    setActiveIndex(index);
    onItemSelect(item);
  }

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp') {
      const newIndex = Math.max(0, activeIndex - 1);
      setActiveIndex(newIndex);
      onItemSelect(cacheAssemblies[newIndex]);
      event.preventDefault(); 
    } else if (event.key === 'ArrowDown') {
      const newIndex = Math.min(cacheAssemblies.length - 1, activeIndex + 1);
      setActiveIndex(newIndex);
      onItemSelect(cacheAssemblies[newIndex]);
      event.preventDefault();
    }
  };
    return (
        <ul className='p-2 no-outline' onKeyDown={handleKeyDown} tabIndex={0}>
            {cacheAssemblies.map((item, index) => (
                <li key={index} className={`cursor-pointer ${index === activeIndex ? 'headerBlue' : ''}`} onClick={() => handleClick(index, item)}>{item.serialNumber}</li>
            ))}
        </ul>
    )
}